<!-- <div class="modal fade" id="modalmodanagrafica" tabindex="-1"
	role="dialog" aria-labelledby="myModalLabel"> -->
<div class="modal-dialog" role="document">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				data-dismiss="modal" (click)="createForm();" type="button">Chiudi</button>
		</p>
		<div>
			<div legali-anagrafica-form-update #formAnagraficaLegali [isLegali]="true" (onReturn)="manageModal($event)"></div>
		</div>
	</div>
</div>